export default {
	lang:'en',
	roof: 'Roof',
	facade: 'Facade',
	searchForAddress: 'Enter address here...',
	address: 'address',
	map: 'map',
	or: 'or',
	clickOn: 'Click on a roof on the',
	selectedAddress: 'Selected address',
	notYetLocalised: 'Not yet localised',
	indicateLocation: 'Indicate your location',
	whatRoofType: 'What roof type do you have?',
	unselected: 'Unselected',
	tile: 'Tile',
	tin: 'Tin',
	other: 'Other / Unknown',
	corrugatedEternit: 'Corrugated Eternit',
	slateEternit: 'Slate Eternit',
	gravel: 'Gravel Flat Roof',
	substrate: 'Substrate Flat Roof',
	wallbox: 'Wallbox',
	wallboxDescription: 'Installing a wallbox is a future-oriented investment in the existing infrastructure. Through intelligent interaction with the solar system, your own fleet can be supplied with cheap electricity today or in the future.', // this string needs to be exactly this length or shorter.
	backupPower: 'Backup Power',
	backupPowerDescription: 'Even in the event of a power failure, the solar system continues to supply the most important installations with electricity. Typically, these are devices such as freezers, lights and communication components (telephone and internet).', // this string needs to be exactly this length or shorter.
	additionalOfferings: 'Additional Offerings',
	yourLocation: 'Roof location and contact',
	mr: 'Mr.',
	mrs: 'Mrs.',
	firstName: 'First name',
	surname: 'Last name',
	email: 'Email',
	phone: 'Phone',
	postalCode: 'Postal Code',
	city: 'City',
	addressCap: 'Address',
	comments: 'Comments',
	addressSameAsAbove: 'Address is the same as above',
	state: 'State',
	street: 'Street',
	submit: 'Submit',
	invalidEmail: 'Invalid e-mail address',
	invalidPhone: 'Invalid phone number',
	invalidCaptcha: 'Captcha token is not valid',
	submissionComplete: 'Request Submitted',
	sendingData: 'Sending Information...',
	submissionError: 'Something went worng !!!',
	apiErrorMessage: 'Service Unavailable: Unable to process your request at this time. Please try again later.',
	apiInvalidCaptchaMessage: 'Your CAPTCHA token is invalid or has expired. Please refresh the page and try again.',
	mandatoryField: 'Field cannot be empty',
	enterCustom: 'Enter your custom',
	customRoof: 'Back to Map',
	mapMode: 'Manual Entry',
	length: 'Length',
	width: 'Width',
	unit: 'm',
	area: 'Area',
	slope: 'Slope',
	data: 'data',
	pleaseEnter: 'Please enter your roof address or add your custom roof data',
	selectRoofType: 'Please enter your roof type',
	clearRoofSelectionLabel: 'Reset',
	orientation: 'Orientation',
	north: 'N',
	northeast: 'NE',
	east: 'O',
	southeast: 'SE',
	south: 'S',
	southwest: 'SW',
	west: 'W',
	northwest: 'NW',
	roof1: 'Roof 1',
	electricityProductionPerYear: 'electricity production per year',
	electricityProductionPerYearUnit: 'kWh',
	amountOfHouseholds: 'Amount of Households',
	financialReturnIn30years: 'Financial Return in 30 years',
	financialReturnIn30yearsUnit: 'CHF',
	deleteTab: 'Delete Roof',
	undo: 'Undo',
	removed: 'removed',
	welcomeMessage: 'Your personal solar offer in three minutes',
	cookieConsentBanner1: 'We use cookies to improve the user experience.',
	cookieConsentBanner2: 'By using our site, you agree to the use of cookies.',
	acceptButtonText: 'Accept',
	declineButtonText: 'Decline',
	title: "Solar Calculator by Elektrobedarf Troller",  // Add the title
	description: "Electricity from sunlight - select the roof, calculate the yield, and request an offer.", // Add the description
	publisher: "Publisher and responsible for the content: Patrick Troller, Managing Director",
	development: "Development:",
	t2consultAddress: "Am Heidberg 14, 24211 Preetz - Germany",
	additionalSuccessMessage: "Thank you! Your personal solar consultant is now preparing your individual offer.",
	consultantHint: "ⓘ Every offer is personally reviewed by a solar expert and tailored to your roof. Your data is treated confidentially and will not be passed on to third parties.",
	nextStep: "Next",
	nextToRoofType: "Next: Roof Type",
	directContact: "Contact Us",
	nextToTeaser: "Next: Overview",
	nextToOfferings: "Next: Additional Offerings",
	nextToContact: "Next: Contact Details",
	backToAddress: "Back to Address",
	backToRoofType: "Back to Roof Type",
	backToTeaser: "Back to Overview",
	backToOfferings: "Back to Offerings",
	teaserHeading: "Your personal solar potential",
	teaserSubheading: "Based on this data, we will prepare your individual offer.",
	offeringsHint: "These options will be discussed in detail during your personal consultation.",
	solarSuitability: "Solar suitability",
	solarExcellent: "Excellent",
	solarVeryGood: "Very good",
	solarGood: "Good",
	solarMedium: "Medium",
	solarLow: "Low",
	addAnotherRoof: '+ Add another roof',
	enterAddressHint: 'Enter your address or select your roof on the map',
	doubleClickHint: 'Double-click on a building = select entire roof',
	doubleTapHint: 'Double-tap on a building = select entire roof',
	maxRoofsReached: 'Maximum 3 roofs reached. More roofs? Please note in the comments field – a solar expert will take care of your project.',
}